import apiHandler from "../core/apiHandler";

const productSizeApi = apiHandler("product-sizes");
export default productSizeApi;
